<template>
  <div class="sidebar-box">
    <h6>{{ $t('ticket.detalle.detalle_operacion') }}</h6>
    <DxButton v-bind="{ ...primaryButtonProps(), icon: 'fa-solid fa-magnifying-glass fa-sm' }"
      :text="$t('ticket.detalle.ver_detalle')" :class="'w-100 mt-3'" @click="emit('ver-detalle')" />
  </div>
</template>

<script setup lang="ts">
import { DxButton } from "devextreme-vue";
import type { DetailTicketModel } from "@api/api";
import { primaryButtonProps } from "@/.shared/helpers/button-helper";

defineProps<{
  model: DetailTicketModel;
}>();

const emit = defineEmits<{
  "ver-detalle": [];
}>();
</script>
